// imports
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import Divider from '@mui/material/Divider';

// local imports
import AdditionalLayer from './AdditionalLayer/AdditionalLayer';
import ReusableAccordion from '../ReusableAccordion/ReusableAccordion';
import WatershedAdditionalLayer from '../WaterDataAccordion/WatershedAdditionalLayer/WatershedAdditionalLayer';
import { useLayerUrlSync } from '../../../hooks/useUrlParameters';

interface LayersAccordionAccordionProps {
  expanded: boolean;
  onChange: (event: React.SyntheticEvent, newExpanded: boolean) => void;
}

const StyledSectionHeader = styled(Typography)(({ theme }) => ({
  textTransform: 'uppercase',
  fontWeight: 'normal',
  marginBottom: theme.spacing(1),
  textAlign: 'left',
  color: theme.palette.text.secondary,
  fontSize: '1rem',
  lineHeight: 1,
  borderTop: `1px solid ${theme.palette.divider}`,
  paddingTop: theme.spacing(2),
}));

const StyledDivider = styled(Divider)(() => ({
  marginTop: '8px',
  marginLeft: 0
}));

export default function LayersAccordion({
  expanded,
  onChange,
}: LayersAccordionAccordionProps) {
  // On load get layers from URL, and when the visible layers change, update URL
  useLayerUrlSync();

  return (
    <ReusableAccordion
      title="Additional Layers"
      expanded={expanded}
      onChange={onChange}
      accordionStyles={{
        '& .MuiAccordionDetails-root': {
          pr: 0,
        },
      }}
    >
      <Box component="section">
        <StyledSectionHeader role="heading" aria-level={3} variant="body2" sx={{pt: 2, borderTop: 'none'}}>
          Administrative Boundaries
        </StyledSectionHeader>
        <Box sx={{ mb: 2 }}>
          <AdditionalLayer id="counties" />
          <StyledDivider variant="middle" />
          <AdditionalLayer id="states" />
        </Box>
        <StyledSectionHeader role="heading" aria-level={3} variant="body2">
          Hydrology
        </StyledSectionHeader>
        <Box sx={{ mb: 2 }}>
          <AdditionalLayer id="nhdNetworkFlowline" />
          <StyledDivider variant="middle" />
          <AdditionalLayer id="aquifers" />
          <StyledDivider variant="middle" />
          <WatershedAdditionalLayer />
          <StyledDivider variant="middle" />
          <AdditionalLayer id="reservoirs" />
          <StyledDivider variant="middle" />
          <AdditionalLayer id="nri" />
        </Box>
        <StyledSectionHeader role="heading" aria-level={3} variant="body2">
          Land Use
        </StyledSectionHeader>
        <Box sx={{ mb: 2 }}>
          <AdditionalLayer id="cropland" />
          <StyledDivider variant="middle" />
          <AdditionalLayer id="nlcd" />
        </Box>
        <StyledSectionHeader role="heading" aria-level={3} variant="body2">
          Infrastructure
        </StyledSectionHeader>
        <Box sx={{ mb: 2 }}>
          {/* <AdditionalLayer id="dams" /> */}
          {/* <StyledDivider variant="middle" /> */}
          <AdditionalLayer id="railroads" />
        </Box>
      </Box>
    </ReusableAccordion>
  );
}
